<div class="order-status-rating-text ods-typography-body-s-bold">{{ title | translate }}:</div>
<div
  [reactComponent]="RatingComponent$"
  [props]="{
    rating,
    size: 32,
    disabled: state === 'RATED',
    onChange: onChangeRatingCallBack
  }"
></div>
